/*
*###############################################################################
*Module Name                   : TransactionTAX.js                             #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  T A C Priyashad                              #
*Date                          : Thursday, October 14th 2021, 10:07:06 am      #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/


function AddTaxDetailsToTaxList(itemTaxList, setTaxTable, currentTaxSet, proDesc, amount, rowID) {

    var taxTable = [...currentTaxSet]
    itemTaxList.map((dr, index) => {
        if (dr.active) {
            taxTable.push({
                proCode: dr.plucode,
                proDesc: proDesc,
                taxRate: dr.taxrate,
                taxInclusive: dr.inclusive,
                grossAmt: amount,
                taxtCode: dr.taxcode,
                taxDesc: dr.taxdesc,
                taxtDispRate: dr.taxdisprate,
                dtailRowID: rowID
            })
        }
    })
    //console.log(1)
    setTaxTable(taxTable)
}


function CalculateTaxItemTotalChange(proCode, grossAmount, currentTaxSet, SetTaxTable) {

    var taxTable = [...currentTaxSet]

    var taxItem = taxTable.find(x => x.proCode === proCode)

    taxItem.grossAmt = grossAmount

    var newTaxSet = []
    for (var i = 0; i < taxTable.length; i++) {
        if (taxTable[i].proCode === proCode) {
            newTaxSet.push(taxItem)
        } else {
            newTaxSet.push(taxTable[i])
        }
    }

    SetTaxTable(newTaxSet)

}

function CalculateTax(setTaxTable, currentTaxSet, gridTable,) {

    var grid = [...gridTable]
    var taxTable = [...currentTaxSet]
    var newTaxSet = []

    for (var i = 0; i < grid.length; i++) {

        var taxItem = taxTable.filter(x => x.proCode == grid[i].strDET_PROCODE && x.dtailRowID == grid[i].id)

        if (taxItem != undefined && taxItem != null) {
            for (var j = 0; j < taxItem.length; j++) {
                taxItem[j].grossAmt = grid[i].dcDET_AMOUNT
                newTaxSet.push(taxItem[j])
            }
        }

    }

    //console.log(2)
    setTaxTable(newTaxSet)

}

//calculate tax with reference quantity
function CalculateTaxWithRefQty(setTaxTable, currentTaxSet, gridTable, refQtyLoad) {

    var grid = [...gridTable]
    var taxTable = [...currentTaxSet]
    var newTaxSet = []

    for (var i = 0; i < grid.length; i++) {

        var taxItem = taxTable.filter(x => x.proCode == grid[i].strDET_PROCODE && x.dtailRowID == grid[i].id)

        if (taxItem != undefined && taxItem != null) {
            for (var j = 0; j < taxItem.length; j++) {
                taxItem[j].grossAmt = grid[i].dcDET_AMOUNT
                newTaxSet.push(taxItem[j])
            }
        }

    }
    //console.log(3)
    setTaxTable(newTaxSet)

}


async function CalculateTaxFrom(setTaxTable, detailTable, taxTable) {

    var newTaxTable = []

    detailTable.map((dr, index1) => {
        taxTable.map((tax, index) => {
            newTaxTable.push({
                proCode: dr.strDET_PROCODE,
                proDesc: dr.strDET_PRODESC,
                taxRate: tax.taxrate,
                taxInclusive: tax.inclusive,
                grossAmt: dr.dcDET_AMOUNT,
                taxtCode: tax.taxcode,
                taxDesc: tax.taxdesc,
                taxtDispRate: tax.taxdisprate,
                dtailRowID: dr.id
            })
        })
    })
    //console.log(4)
    setTaxTable(newTaxTable)

}



function TaxCalculateFromExcel(setTaxTable, detailTable, taxTable) {

    var endTaxTable = []

    detailTable.map((dr, index1) => {
        var taxItems = taxTable.filter(x => x.TPLU_CODE == dr.strDET_PROCODE)
        if (taxItems.length > 0) {
            taxItems.map((tax, index) => {
                if (tax.TPLU_ACTIVE == 1) {
                    endTaxTable.push({
                        proCode: dr.strDET_PROCODE,
                        proDesc: dr.strDET_PRODESC,
                        taxRate: tax.TAX_RATE,
                        taxInclusive: tax.ST_TAXINC,
                        grossAmt: dr.dcDET_AMOUNT,
                        taxtCode: tax.TAX_CODE,
                        taxDesc: tax.TAX_DESC,
                        taxtDispRate: tax.TAX_DISPLAYRATE,
                        dtailRowID: dr.id
                    })
                }
            })
        }
    })
    //console.log(5)
    setTaxTable(endTaxTable)
}


const CalculateTaxWithTransactionRelatedTax = async (txnTax, taxTable, productTax, lineAmount, ProductDesc, rowID, txnDecimalAmt) => {

    //console.log(1)

    let currentTaxSet = [...taxTable];
    //get max line number
    let maxLineNo = 0;
    currentTaxSet.forEach(item => {
        if (item.id > maxLineNo) {
            maxLineNo = item.id;
        }
    });

    productTax.forEach(item => {
        const isTaxAvailable = txnTax.find(x => x.taxCode === item.taxcode);

        if (isTaxAvailable) {
            let calculatedGrossAmount = parseFloat(lineAmount);

            if (isTaxAvailable.taxDepend == 1) {
                const dependentTaxTypes = isTaxAvailable.taxLevels.split(',').sort();

                dependentTaxTypes.forEach(orderNo => {
                    const taxItem = txnTax.find(x => x.taxOrder == String(orderNo).trim());

                    if (taxItem && taxItem.taxInclusive == 0) {
                        const itemHaveSelectedTax = productTax.find(x => x.taxcode == taxItem.taxCode);
                        if (itemHaveSelectedTax) {
                            const taxAmount = (calculatedGrossAmount * parseFloat(taxItem.taxRate)) / 100;
                            calculatedGrossAmount += taxAmount;
                        }
                    } else if (taxItem && taxItem.taxInclusive == 1) {
                        const itemHaveSelectedTax = productTax.find(x => x.taxcode == taxItem.taxCode);
                        if (itemHaveSelectedTax) {
                            const taxAmount = (calculatedGrossAmount * parseFloat(taxItem.taxRate)) / (100 + parseFloat(taxItem.taxRate));
                            calculatedGrossAmount -= taxAmount;
                        }
                    }
                });
            }

            let taxAmount = 0;
            if (isTaxAvailable.taxInclusive) {
                taxAmount = (calculatedGrossAmount * parseFloat(isTaxAvailable.taxRate)) / (100 + parseFloat(isTaxAvailable.taxRate));
            } else {
                taxAmount = (calculatedGrossAmount * parseFloat(isTaxAvailable.taxRate)) / 100;
            }

            currentTaxSet.push({
                proCode: item.plucode,
                proDesc: ProductDesc,
                taxInclusive: isTaxAvailable.taxInclusive,
                taxCode: item.taxcode,
                taxDesc: item.taxdesc,
                taxRate: isTaxAvailable.taxRate, // Assuming `dr.taxdisprate` should be `isTaxAvailable.taxRate`
                detailRowID: rowID,
                //sequenceNo: isTaxAvailable.taxOrder,
                grossAmt: parseFloat(parseFloat(calculatedGrossAmount).toFixed(txnDecimalAmt)),
                taxAmount: parseFloat(parseFloat(taxAmount).toFixed(txnDecimalAmt)),
                id: maxLineNo + 1,
            });
            maxLineNo += 1;
        }
    });

    return currentTaxSet;
};


const CalculateTaxAmountFromDetailTable = async (detailTable, txnTax, taxTable, txnDecimalAmt) => {
    //console.log(2)
    let newTaxList = []
    let maxLineNo = 0;
    detailTable.forEach((detailItem) => {

        const productTax = taxTable.filter(x => x.proCode == detailItem.strDET_PROCODE && x.detailRowID == detailItem.id);

        if (productTax) {
            //console.log(productTax)
            productTax.forEach((item) => {

                const isTaxAvailable = txnTax.find(x => x.taxCode === item.taxCode);

                if (isTaxAvailable) {

                    let calculatedGrossAmount = parseFloat(detailItem.dcDET_AMOUNT);

                    if (isTaxAvailable.taxDepend == 1) {
                        const dependentTaxTypes = isTaxAvailable.taxLevels.split(',').sort();

                        dependentTaxTypes.forEach(orderNo => {
                            const taxItem = txnTax.find(x => x.taxOrder == String(orderNo).trim());

                            if (taxItem && taxItem.taxInclusive == 0) {
                                const itemHaveSelectedTax = productTax.find(x => x.taxCode == taxItem.taxCode);
                                if (itemHaveSelectedTax) {
                                    const taxAmount = (calculatedGrossAmount * parseFloat(taxItem.taxRate)) / 100;
                                    calculatedGrossAmount += taxAmount;
                                }
                            } else if (taxItem && taxItem.taxInclusive == 1) {
                                const itemHaveSelectedTax = productTax.find(x => x.taxCode == taxItem.taxCode);
                                if (itemHaveSelectedTax) {
                                    const taxAmount = (calculatedGrossAmount * parseFloat(taxItem.taxRate)) / (100 + parseFloat(taxItem.taxRate));
                                    calculatedGrossAmount -= taxAmount;
                                }
                            }
                        });
                    }

                    let taxAmount = 0;
                    if (isTaxAvailable.taxInclusive) {
                        taxAmount = (calculatedGrossAmount * parseFloat(isTaxAvailable.taxRate)) / (100 + parseFloat(isTaxAvailable.taxRate));
                    } else {
                        taxAmount = (calculatedGrossAmount * parseFloat(isTaxAvailable.taxRate)) / 100;
                    }

                    newTaxList.push({
                        proCode: item.proCode,
                        proDesc: item.proDesc,
                        taxInclusive: isTaxAvailable.taxInclusive,
                        taxCode: item.taxCode,
                        taxDesc: item.taxDesc,
                        taxRate: isTaxAvailable.taxRate,
                        detailRowID: detailItem.id,
                        //sequenceNo: isTaxAvailable.taxOrder,
                        grossAmt: parseFloat(parseFloat(calculatedGrossAmount).toFixed(txnDecimalAmt)),
                        taxAmount: parseFloat(parseFloat(taxAmount).toFixed(txnDecimalAmt)),
                        id: maxLineNo + 1
                    });
                    maxLineNo += 1;
                }
            });

        }

    })

    return newTaxList

}



const ModifyTaxGrid = async (taxList, detailTable, setTaxTable, txnDecimalAmt) => {

    let newTaxList = []
    let maxLineNo = 0;

    taxList.forEach(dr => {
        const Item = detailTable.find(x => {
            return x.strDET_PROCODE == dr.strTDET_PROCODE && x.dcDET_LINENO == dr.dcTDET_LINENO;
        })

        if (Item) {
            newTaxList.push({
                proCode: dr.strTDET_PROCODE,
                proDesc: Item.strDET_PRODESC ?? "",
                taxInclusive: dr.blTDET_TAXINC ? 1 : 0,
                taxCode: dr.strTDET_TAXCODE,
                taxDesc: dr.strTDET_TAXCODE,
                taxRate: dr.dcTDET_TAXRATE,
                detailRowID: dr.dcTDET_LINENO,
                grossAmt: parseFloat(parseFloat(dr.dcTDET_GROAMT).toFixed(txnDecimalAmt)),
                taxAmount: parseFloat(parseFloat(dr.dcTDET_TAXAMT).toFixed(txnDecimalAmt)),
                id: maxLineNo + 1
            })
            maxLineNo += 1
        }

    })

    setTaxTable(newTaxList)
    console.log(newTaxList)

    return newTaxList
}


const CalculateTaxAmount = async (taxtableWithoutTaxAmount, setTaxTable, txnTax, txnDecimalAmt) => {
    //console.log(3)
    let newTaxList = []
    let maxLineNo = 0;

    taxtableWithoutTaxAmount.forEach((dr) => {

        const isTaxAvailable = txnTax.find(x => x.taxCode === dr.taxCode);

        const itemTaxList = taxtableWithoutTaxAmount.filter(x => x.productCode == dr.productCode && x.lineNo == dr.lineNo);

        if (isTaxAvailable) {

            let calculatedGrossAmount = parseFloat(dr.lineAmount);

            if (isTaxAvailable.taxDepend == 1) {
                const dependentTaxTypes = isTaxAvailable.taxLevels.split(',').sort();

                dependentTaxTypes.forEach(orderNo => {
                    const taxItem = txnTax.find(x => x.taxOrder == String(orderNo).trim());

                    if (taxItem && taxItem.taxInclusive == 0) {
                        const itemHaveSelectedTax = itemTaxList.find(x => x.taxCode == taxItem.taxCode);
                        if (itemHaveSelectedTax) {
                            const taxAmount = (calculatedGrossAmount * parseFloat(taxItem.taxRate)) / 100;
                            calculatedGrossAmount += taxAmount;
                        }
                    } else if (taxItem && taxItem.taxInclusive == 1) {
                        const itemHaveSelectedTax = itemTaxList.find(x => x.taxCode == taxItem.taxCode);
                        if (itemHaveSelectedTax) {
                            const taxAmount = (calculatedGrossAmount * parseFloat(taxItem.taxRate)) / (100 + parseFloat(taxItem.taxRate));
                            calculatedGrossAmount -= taxAmount;
                        }
                    }
                });
            }

            let taxAmount = 0;
            if (isTaxAvailable.taxInclusice) {
                taxAmount = (calculatedGrossAmount * parseFloat(isTaxAvailable.taxRate)) / (100 + parseFloat(isTaxAvailable.taxRate));
            } else {
                taxAmount = (calculatedGrossAmount * parseFloat(isTaxAvailable.taxRate)) / 100;
            }

            newTaxList.push({
                proCode: dr.productCode,
                proDesc: dr.productName,
                taxInclusive: isTaxAvailable.taxInclusive,
                taxCode: dr.taxCode,
                taxDesc: dr.taxCode,
                taxRate: isTaxAvailable.taxRate,
                detailRowID: dr.lineNo,
                grossAmt: parseFloat(parseFloat(calculatedGrossAmount).toFixed(txnDecimalAmt)),
                taxAmount: parseFloat(parseFloat(taxAmount).toFixed(txnDecimalAmt)),
                id: maxLineNo + 1
            });
            maxLineNo += 1;
        }
    });

    setTaxTable(newTaxList);

    return newTaxList;

};



const ModifyTaxGridFromExcel = async (txnTaxTypes, taxList, detailTable, setTaxTable, txnDecimalAmt) => {


    let newTaxList = []
    let maxLineNo = 0;

    taxList.forEach(dr => {

        const Item = detailTable.find(x => {
            return x.strDET_PROCODE == dr.TPLU_CODE && x.dcDET_LINENO == dr.dcDET_LINENO;
        })

        if (Item) {

            const isTaxAvailable = txnTaxTypes.find(x => x.taxCode == dr.TPLU_TAXCODE);

            if (isTaxAvailable) {

                newTaxList.push({
                    proCode: dr.TPLU_CODE,
                    proDesc: Item.strDET_PRODESC ?? "",
                    taxInclusive: isTaxAvailable.taxInclusive,
                    taxCode: dr.TPLU_TAXCODE,
                    taxDesc: dr.TPLU_TAXCODE,
                    taxRate: isTaxAvailable.taxRate,
                    detailRowID: Item.dcDET_LINENO,
                    grossAmt: parseFloat(parseFloat(0).toFixed(txnDecimalAmt)),
                    taxAmount: parseFloat(parseFloat(0).toFixed(txnDecimalAmt)),
                    id: maxLineNo + 1
                })
                maxLineNo += 1

            }

        }
    })

    setTaxTable(newTaxList)
    return newTaxList
}



const ModifyTaxGridFromMobileMan = async (txnTaxTypes, taxList, detailTable, setTaxTable, txnDecimalAmt) => {

    let newTaxList = []
    let maxLineNo = 0;

    taxList.forEach(dr => {

        const Item = detailTable.find(x => {
            return x.strDET_PROCODE == dr.plU_CODE && x.dcDET_LINENO == dr.linE_NUMBER;
        })

        if (Item) {

            const isTaxAvailable = txnTaxTypes.find(x => x.taxCode == dr.taX_CODE);

            if (isTaxAvailable) {

                newTaxList.push({
                    proCode: dr.plU_CODE,
                    proDesc: Item.strDET_PRODESC ?? "",
                    taxInclusive: isTaxAvailable.taxInclusive,
                    taxCode: dr.taX_CODE,
                    taxDesc: dr.taX_CODE,
                    taxRate: isTaxAvailable.taxRate,
                    detailRowID: Item.dcDET_LINENO,
                    grossAmt: parseFloat(parseFloat(0).toFixed(txnDecimalAmt)),
                    taxAmount: parseFloat(parseFloat(0).toFixed(txnDecimalAmt)),
                    id: maxLineNo + 1
                })
                maxLineNo += 1

            }

        }
    })

    setTaxTable(newTaxList)
    return newTaxList
}



const CalcualteVariantTax = (txnTax, taxTable, setTaxTable, productTax, txnDecimalAmt, variantItemList) => {
    //console.log(4)
    let currentTaxSet = [...taxTable];
    //get max line number
    let maxLineNo = 0;
    currentTaxSet.forEach(item => {
        if (item.id > maxLineNo) {
            maxLineNo = item.id;
        }
    });

    productTax.forEach(item => {
        const isTaxAvailable = txnTax.find(x => x.taxCode === item.taxcode);

        if (isTaxAvailable) {

            variantItemList.forEach((variantItem) => {

                let calculatedGrossAmount = parseFloat(variantItem.dcDET_AMOUNT);


                if (isTaxAvailable.taxDepend == 1) {
                    const dependentTaxTypes = isTaxAvailable.taxLevels.split(',').sort();

                    dependentTaxTypes.forEach(orderNo => {
                        const taxItem = txnTax.find(x => x.taxOrder == String(orderNo).trim());

                        if (taxItem && taxItem.taxInclusive == 0) {
                            const itemHaveSelectedTax = productTax.find(x => x.taxcode == taxItem.taxCode);
                            if (itemHaveSelectedTax) {
                                const taxAmount = (calculatedGrossAmount * parseFloat(taxItem.taxRate)) / 100;
                                calculatedGrossAmount += taxAmount;
                            }
                        } else if (taxItem && taxItem.taxInclusive == 1) {
                            const itemHaveSelectedTax = productTax.find(x => x.taxcode == taxItem.taxCode);
                            if (itemHaveSelectedTax) {
                                const taxAmount = (calculatedGrossAmount * parseFloat(taxItem.taxRate)) / (100 + parseFloat(taxItem.taxRate));
                                calculatedGrossAmount -= taxAmount;
                            }
                        }
                    });
                }


                let taxAmount = 0;
                if (isTaxAvailable.taxInclusive) {
                    taxAmount = (calculatedGrossAmount * parseFloat(isTaxAvailable.taxRate)) / (100 + parseFloat(isTaxAvailable.taxRate));
                } else {
                    taxAmount = (calculatedGrossAmount * parseFloat(isTaxAvailable.taxRate)) / 100;
                }

                currentTaxSet.push({
                    proCode: item.plucode,
                    proDesc: variantItem.strDET_PRODESC,
                    taxInclusive: isTaxAvailable.taxInclusive,
                    taxCode: item.taxcode,
                    taxDesc: item.taxdesc,
                    taxRate: isTaxAvailable.taxRate, // Assuming `dr.taxdisprate` should be `isTaxAvailable.taxRate`
                    detailRowID: variantItem.id,
                    //sequenceNo: isTaxAvailable.taxOrder,
                    grossAmt: parseFloat(parseFloat(calculatedGrossAmount).toFixed(txnDecimalAmt)),
                    taxAmount: parseFloat(parseFloat(taxAmount).toFixed(txnDecimalAmt)),
                    id: maxLineNo + 1,
                });
                maxLineNo += 1;


            });

        }
    });

    setTaxTable(currentTaxSet);


}



export {
    AddTaxDetailsToTaxList, CalculateTaxItemTotalChange, CalculateTax,
    CalculateTaxFrom, TaxCalculateFromExcel, CalculateTaxWithTransactionRelatedTax,
    CalculateTaxAmountFromDetailTable, ModifyTaxGrid, CalculateTaxAmount, ModifyTaxGridFromExcel,
    ModifyTaxGridFromMobileMan, CalcualteVariantTax
}






